import * as turf from "@turf/turf";
import { ensureClosedPolygon } from "helpers/ensureClosedPolygon";

export const calculateArea = (coordinates) => {
  const polygonCoordinates = ensureClosedPolygon(coordinates).map(
    ([lat, lng]) => [lng, lat]
  );
  const polygon = turf.polygon([polygonCoordinates]);

  const areaInSquareMeters = turf.area(polygon);
  const areaInHectares = areaInSquareMeters / 10000;

  return {
    areaInSquareMeters,
    areaInHectares,
    polygonCoordinates
  };
};
